import React from 'react';
import type { ProjectType } from '@atlassian/jira-common-constants/src/project-types';
import { ContextualAnalyticsData, SCREEN } from '@atlassian/jira-product-analytics-bridge';
import ArchiveProjectModalAsync from '@atlassian/jira-project-archive-modal/src/async';
import type { ModalProps as AppProps } from '@atlassian/jira-project-archive-modal/src/types';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller';
import type { ModalProps } from '../../types';

export type ArchiveProjectModalOptions = {
	projectId: number;
	projectName: string;
	projectType: ProjectType;
	isProjectSimplified: boolean;
};

export type Props = AppProps & ModalProps;

const ArchiveProject = ({ baseUrl, onClose, projectName, projectId, projectType }: Props) => {
	const isAdmin = useIsAdmin();

	const onArchiveSuccess = () => {
		if (isAdmin) {
			window.location.replace('/jira/settings/projects/manage');
		} else {
			window.location.replace('/jira/projects');
		}
	};

	return (
		<ContextualAnalyticsData sourceName="EditProjectDetails" sourceType={SCREEN}>
			<ArchiveProjectModalAsync
				isProjectSimplified={false}
				onClose={onClose}
				baseUrl={baseUrl}
				projectName={projectName}
				projectId={projectId}
				projectType={projectType}
				onArchiveSuccess={onArchiveSuccess}
				onArchiveSuccessFlagRestore={undefined}
			/>
		</ContextualAnalyticsData>
	);
};

export default ArchiveProject;
